import { useIntl } from 'react-intl';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import IconCardsSchema from './schema';
import IconCardsView from './IconCardsView';
import type { IconCardsData } from './IconCardsView';

type IconCardsEditProps = {
  data: IconCardsData;
  block: string;
  selected: boolean;
  onChangeBlock: (block: string, data: IconCardsData) => void;
};

const IconCardsEdit = (props: IconCardsEditProps) => {
  const { data, block, onChangeBlock, selected } = props;
  const intl = useIntl();
  const schema = IconCardsSchema({ intl });

  return (
    <>
      <IconCardsView data={data} />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          onChangeField={(id: string, value: unknown) => {
            onChangeBlock(block, { ...data, [id]: value });
          }}
          formData={data}
          block={block}
        />
      </SidebarPortal>
    </>
  );
};

export default IconCardsEdit;
